export default __webpack_public_path__ + "static/media/dry_cool_3.17674de2.jpg";